var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiDarkCrane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.683,
    height: 151.053,
    viewBox: "0 0 174.683 151.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crane43",
    transform: "translate(4.848 0.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2165708814976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M22.445,13.365,0,0,.234,6.968Z",
    transform: "translate(143.804 1.101)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M166.254,14.464,143.8,1.1l-1.43.547L138.66,0l-2.937,4.187L122.934,69.034l20.52,22.941L143.8,1.1l-.023,6.911ZM87.863,112.906,0,148.979l111.129-21.562,5.563-27.8,26.762-7.645-36.43-40.181-8.937-3.842-5.824-6.2L22.711,11.8l2.965,5.021L94.148,46.264,20.254,14.494l49.934,87.392,17.676,11.021Z",
    transform: "translate(0 0.001)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M20.922,0,12.844,3.089,0,68.19,20.578,90.874Z",
    transform: "translate(122.885 1.101)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M6.648,1.647,2.945,0,0,4.189Z",
    transform: "translate(135.722 0)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M123.2,77.479,86.766,37.3,0,0,96.438,85.125Z",
    transform: "translate(20.262 14.496)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M96.438,85.125l-5.574,27.8L49.93,87.39,0,0Z",
    transform: "translate(20.262 14.496)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M0,0,4.758,43.487l13.453-23.4Z",
    transform: "translate(107.027 51.795)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M13.461,0,31.68,20.09,4.93,27.736,0,23.4Z",
    transform: "translate(111.783 71.885)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M23.922,0,0,17.623,23.266,32.137l5.57-27.8Z",
    transform: "translate(87.866 95.282)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M41.594,0,0,6.6l17.656,11.02Z",
    transform: "translate(70.189 95.282)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M75.367,36.148l-5.828-6.2L0,0,2.961,5.02Z",
    transform: "translate(22.724 11.805)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M87.855,0,0,36.072,111.129,14.512Z",
    transform: "translate(0 112.906)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiDarkCrane);
export default __webpack_public_path__ + "static/media/origami-dark-crane.cc87dff72b15c7776258f79d42d3c3d9.svg";
export { ForwardRef as ReactComponent };